import { Navigate, Route, Routes } from "react-router-dom";

import { AuthLayout } from "@/components/auth/auth-layout";

import AcceptInvitationPage from "./pages/accept-invitation";
import ChooseOrganizationPage from "./pages/choose-organization";
import ChooseOrganizationTaskPage from "./pages/session-tasks/choose-organization";
import SignInEmailPage from "./pages/sign-in/email";
import NewPasswordPage from "./pages/sign-in/new-password";
import SignInPasswordPage from "./pages/sign-in/password";
import ResetCodePage from "./pages/sign-in/reset";
import DeviceTrustPage from "./pages/sign-in/verify";
import SignUpEntry from "./pages/sign-up/entry";
import SignUpOrganizationPage from "./pages/sign-up/organization";
import PublicSignUpGate from "./pages/sign-up/public-gate";
import SignUpVerifyPage from "./pages/sign-up/verify";
import SsoCallbackPage from "./pages/sso-callback";

const App = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route element={<SignInEmailPage />} path="/login" />
      <Route element={<SignInPasswordPage />} path="/login/password" />
      <Route element={<DeviceTrustPage />} path="/login/verify" />
      <Route element={<ResetCodePage />} path="/login/reset" />
      <Route element={<NewPasswordPage />} path="/login/reset/password" />
      <Route element={<PublicSignUpGate modes={["public", "waitlist"]} />}>
        <Route element={<SignUpEntry />} path="/signup" />
      </Route>
      <Route element={<PublicSignUpGate modes={["public"]} />}>
        <Route element={<SignUpVerifyPage />} path="/signup/verify" />
        <Route
          element={<SignUpOrganizationPage />}
          path="/signup/organization"
        />
      </Route>
      <Route
        element={<ChooseOrganizationTaskPage />}
        path="/session-tasks/choose-organization"
      />
      <Route
        element={<NewPasswordPage task />}
        path="/session-tasks/reset-password"
      />
      <Route element={<SsoCallbackPage />} path="/sso-callback" />
      <Route element={<ChooseOrganizationPage />} path="/choose-organization" />
      <Route element={<AcceptInvitationPage />} path="/accept-invitation" />
    </Route>
    <Route element={<Navigate replace to="/login" />} path="/sign-in" />
    <Route element={<Navigate replace to="/signup" />} path="/sign-up" />
    <Route
      element={<Navigate replace to="/login/reset" />}
      path="/forgot-password"
    />
    <Route element={<Navigate replace to="/login" />} path="/" />
    <Route element={<Navigate replace to="/login" />} path="*" />
  </Routes>
);

export default App;
